
import request from '../ajax_request.js'
import {base_url,debug_obj,base_api} from "../base_api"

// export function get_table_schema(tableName) {
//     return request({
//         url: `${def_schema_url}${tableName}/schema`,
//         method: 'get'
//     })
// }
let  def_base_url =  base_url+ '/pos'

export function lookup_vip(mobile){

	return  base_api({
				method:'get',
				schema:'vip',
				params:{
					oper:'get',
					mobile
				}
			})
}

export function create_or_update_vip(type='add',{data}){
	
	return  base_api({
			method:'post',
			schema:'vip',
			params:{
				oper:type,
			},
			data
		})
}

export function lookup_vip_saved_products(mobile){
	return  base_api({
			method:'get',
			schema:'vip',
			params:{
				oper:saved,
				mobile
			},
			data
		})
}

export function vip_recharge({params,data}){
	return  base_api({
			method:'post',
			schema:'vip',
			params:{
				oper:'prepay',
			},
			data
		})
}




// WEBPACK FOOTER //
// ./src/api/module/vip.js